export const siteData = {
  name: "Pai Thai Massage",
  phone: "61 38 00 03",
  address: "Labæk 59, 4300 Holbæk",
  hero: {
    title: "Velkommen til Pai Thai Massage",
    subtitle: "Træd ind i en verden af ro, balance og fornyet energi.",
    description: "Hos os møder du den traditionelle Thai massage, hvor gamle teknikker kombineres med moderne velvære – alt sammen med fokus på dig og din krop.",
    cta: "Bestil tid nu",
    image: "https://assets.auxodev.dk/assets/827bf07b-63d5-4b3e-a53e-0e890a6a1d87/ce1f9d32-259d-4ab4-b6ce-737bdd19d3b2.jpg"
  },
  about: {
    title: "Traditionel Thailandsk Massage",
    content: "Her får du en pause fra hverdagens tempo og et pusterum, hvor der er plads til at genfinde balancen. Vi tilbyder professionelle behandlinger udført af erfarne massører, der sikrer dig den bedste oplevelse."
  }
};
